import styled from 'styled-components';
import BannerBG from 'common/src/assets/image/hosting/contactus_banner.jpg';

const BannerWrapper = styled.section`
  background-image: url(${BannerBG});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center 0;
  color: #ffffff;
  display: flex;
  align-items: center;

  height: 40vh;

  .particle {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    @media (max-width: 767px) {
      display: none;
    }
  }

  .banner_container {
    color: #000;
    position: relative;
    margin-left: auto;
    margin-right: auto;
    margin-top: 200px;
    width: auto;
    padding: 40px;
  }
  .title {
    font-weight: 600;
    font-size: 22px;
    margin: 0;
  }

  @media (min-width: 576px) {
    height: 45vh;

    .banner_container {
      margin-top: 200px;
      padding: 40px;
    }
    .title {
      font-size: 25px;
    }
  }

  @media (min-width: 768px) {
    height: 50vh;

    .banner_container {
      margin-top: 250px;
      padding: 40px;
    }
    .title {
      font-size: 30px;
    }
  }

  @media (min-width: 992px) {
    height: 55vh;

    .banner_container {
      margin-top: 280px;
      padding: 40px;
    }
    .title {
      font-size: 35px;
    }
  }

  @media (min-width: 1200px) {
    height: 58vh;
    .banner_container {
      margin-top: 300px;
      padding: 40px;
    }
    .title {
      font-size: 48px;
    }
  }
`;

export default BannerWrapper;
